import SnackbarService from 'services/snackbars'
import { getUserById } from 'services/user'
import { action } from '../../dispatchAction'
import { USER_ACTION_TYPES } from '../types'

export const updateUser = (
  data?: any,
  onSuccess: () => void = () => {
    return
  }
) => async (dispatch, getState) => {
  dispatch(action(USER_ACTION_TYPES.update_user_begin))
  try {
    let userData = data
    if (!userData) {
      const userId = getState().user.auth.uid
      userData = getUserById(userId)
    }
    dispatch(action(USER_ACTION_TYPES.update_user_success, { userData }))
    onSuccess()
  } catch (e) {
    SnackbarService.showSnackbar(
      'Sorry, something went wrong (Error 9), Please contact support@giantleap.tech',
      'error'
    )
    dispatch(action(USER_ACTION_TYPES.update_user_error, { message: e }))
  }
}



// WEBPACK FOOTER //
// ./src/store/user/actions/updateUser.action.ts